import classNames from 'classnames'
import { Text, TextProps } from '@lounge-fe/ui-kit'

export const Title = ({
  className,
  as = 'h1',
  children,
  ...props
}: TextProps<'h1'>) => (
  <Text
    as={as}
    variant="title-two"
    className={classNames('text-center mb-2', className)}
    dangerouslySetInnerHTML={{ __html: children?.toString() ?? '' }}
    {...props}
  />
)
